const user_token = {
    getToken : async () => {
        const token = localStorage.getItem('user_token');
        if (token) {
            return token;
        } else {
            return null;
        }
    },

    setToken : async (token) => {
        localStorage.setItem('user_token', token);
    },

    removeToken : async () => {
        localStorage.removeItem('user_token');
    },
};

const client_token = {
    getToken : async () => {
        const token = localStorage.getItem('client_token');
        if (token) {
            return token;
        } else {
            return null;
        }
    },

    setToken : async (token) => {
        localStorage.setItem('client_token', token);
    },

    removeToken : async () => {
        localStorage.removeItem('client_token');
    },
};

const isAuthenticatedAsUser = async () => {
    const token = localStorage.getItem('user_token');
    return !!token;
}

const isAuthenticatedAsClient = async () => {
    const token = localStorage.getItem('client_token');
    return !!token;
}

export default {client_token, user_token, isAuthenticatedAsUser, isAuthenticatedAsClient};